import { useEffect, useMemo } from 'react';
import { isMobile } from '@helpers/geometry';
import { parseQueryListAttributes } from '@helpers/lists';
import { AppFC } from '@types';
import { topSpecialistsFetchGetList } from '@actions/top-specialists/top-specialists-fetch-get-list';
import { geometryGetType } from '@selectors/geometry';
import { topSpecialistsGetList } from '@selectors/top-specialists';
import { useNavigator } from '@hooks/routing';
import { useTypedDispatch, useTypedSelector } from '@hooks/store';
import { LoadMoreButtonWidget } from '@widgets/load-more-button';
import { PaginationWidget } from '@widgets/pagination';
import { TopMembersListItemWidget } from '@widgets/top-members/top-members-list-item';
import { topMembersSceneListItemLinkClassName, TopMembersSceneListStyled, topMembersSceneLoadMoreButtonClassName, topMembersScenePaginationWidgetClassName, TopMembersSceneStyled } from './styled';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const TopMembersScene: AppFC = () => {
  const dispatch = useTypedDispatch();
  const navigator = useNavigator();
  const query = navigator.getQuery();
  const {
    page = 1,
    keepResults
  } = useMemo(() => parseQueryListAttributes(query),
  //
  [query]);
  const apiPage = page - 1;
  const geometryType = useTypedSelector(geometryGetType);
  const maxVisiblePages = isMobile(geometryType) ? 3 : 7;
  const {
    items,
    //
    hasMore,
    totalCount,
    limit
  } = useTypedSelector(topSpecialistsGetList);
  useEffect(() => {
    dispatch(topSpecialistsFetchGetList({
      limit,
      offset: apiPage * limit,
      keepResults
    }));
  }, [apiPage, dispatch, keepResults, limit, page]);
  return _jsxs(TopMembersSceneStyled, {
    children: [_jsx(TopMembersSceneListStyled, {
      children: items.map(item => {
        return _jsx(TopMembersListItemWidget, {
          className: topMembersSceneListItemLinkClassName,
          item: item
        }, item.userId);
      })
    }), !hasMore ? null : _jsx(LoadMoreButtonWidget, {
      className: topMembersSceneLoadMoreButtonClassName,
      totalCount: totalCount,
      pageSize: limit,
      children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0435"
    }), totalCount <= limit ? null : _jsx(PaginationWidget, {
      className: topMembersScenePaginationWidgetClassName,
      totalCount: totalCount,
      maxVisiblePages: maxVisiblePages,
      pageSize: limit
    })]
  });
};